import React from "react";
import { useNavigate } from "react-router-dom";
import { Container} from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import Error from "../error/error";
import Swal from "sweetalert2";
import Image from "../../assets/background.png";
import Image1 from "../../assets/維修按鈕.png";
import Image2 from "../../assets/待完成.png";
import ImageX  from "../../assets/X.png";
import Header from "../../components/header/header";
import './reservationMenu.css' ;
import { authentication } from "../../utils/config";


const ReseravtionMenu = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);


  useEffect(() => {
    // check line account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId") return navigate("/error");
      else if(response.data === "no user" || response.data === "no vertification") return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      else if(response.data.clinic.vip === false) {
        await Swal.fire({
          title: "登錄產品後即可使用",
           
          icon: "warning",
        }) ;
        return navigate("/main") ;
      } 
    };
    auth();



  }, []);

  return (
    <Container
      fluid
      className="vh-100 d-flex flex-column  align-items-center backgroundStyle"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="mt-3 w-100">
      <Header tyle={{ width: "100%" }}>
      <img
          src={ImageX}
          alt="Back"
          style={{ width: "30px", height: "30px" }}
        />
      </Header>
      </div>
      <div className="reservMenu-image-container">
      <img
        src={Image1}
        onClick={() => {
          navigate("/reservationguideline");
        }}
        className="reservMenu-image"
      />


      <img
        src={Image2}
        onClick={() => {
          navigate("/reservList");
        }}
        className="reservMenu-image"
      />
      </div>

    </Container>
  );
};

export default ReseravtionMenu;
